var $ = require("../../lib/jquery-1.11.2.mod.js");
var EventUtil = require("../../lib/eventutil.js");
var console = require("../../lib/logger.js");
var configModule = require("../../define/config.js");
var FrameProxy = require("../../lib/frameproxy.js");
var FrameMessageBroker = require("../../lib/framemessagebroker.js");
var FrameProxyGroup = require("../../lib/frameproxygroup.js");
var Handshake = require("../../helper/handshake.js");
var topBarHelperFunction = require("../../helper/topbarhelperfunction.js");



//=================================
// setup
//
console.info(__GLOBAL_LOG_PREFIX__, "^^^^^^^^^scout.topframe.js start.^^^^^^^");

var mySenderId = "Message.TopFrame";

/*global __GLOBAL_LOG_PREFIX__:true*/
if (__GLOBAL_LOG_PREFIX__ != null) {

    __GLOBAL_LOG_PREFIX__ += "[Frame.TopFrame]";
}

//extensionFrameProxy setup
var extensionFrameProxy = new FrameProxy();
extensionFrameProxy.setSenderId(mySenderId);
console.info(__GLOBAL_LOG_PREFIX__, "extensionFrameProxy init done.");

var frameMessageBroker = new FrameMessageBroker();
frameMessageBroker.setSenderId(mySenderId);
console.info(__GLOBAL_LOG_PREFIX__, "frameMessageBroker init done.");

var frameProxyGroup = new FrameProxyGroup();
console.info(__GLOBAL_LOG_PREFIX__, "frameProxyGroup init done.");

Handshake.frames.topFrame(frameMessageBroker, frameProxyGroup, extensionFrameProxy);
Handshake.topBar.topFrame(frameMessageBroker, extensionFrameProxy);


//=================================
// message processing
//
// 1. ExtensionFrameProxyReady handling
extensionFrameProxy.onMessage("ExtensionFrameProxyReady", function (messageObj, messageProxy) {
    console.log(__GLOBAL_LOG_PREFIX__, "[Frame] Extension Frame Proxy ready!");

    messageProxy.postMessage("PageLoad", {
        documentLocation: window.document.location.href,
        documentDomain: window.document.domain
    });
});


//2. handle top bar creation/destroy/show events
topBarHelperFunction(extensionFrameProxy);
console.info(__GLOBAL_LOG_PREFIX__, "topBarHelperFunction() done.");

//3. handle frame unload
frameProxyGroup.onMessage("FrameUnload", function (messageObj, messageProxy) {
    console.info(__GLOBAL_LOG_PREFIX__, messageObj.senderId + " is unloaded!");

    frameProxyGroup.removeMessageProxy(messageProxy);
});


//prepare extensionFrame
var extensionFrame = $("<iframe/>")
                        .prop("id", "extensionFrame")
                        .prop("name", "extensionFrame")
                        .prop("src", configModule.EXTENSIONFRAME_BACKGROUND_HTML)
                        .css("display", "none");

//===============================
// things to do when document ready
EventUtil.onDocReady(function () {

    // append extensionFrame
    function appendExtensionFrame () {

        $("body").append(extensionFrame);
        console.info(__GLOBAL_LOG_PREFIX__, "extensionFrame appended.");
    }

    appendExtensionFrame();

    extensionFrameProxy.onMessage("ExtensionFrameUnload", function () {
        console.info(__GLOBAL_LOG_PREFIX__, "Extension Frame is unloaded!");

        appendExtensionFrame();
    });
});

//===============================
// Things to do when top frame unload
EventUtil.onEvent(window, "unload", function() {

    frameMessageBroker.offMessage("ExtensionFrameUnload");
});

// Workaround for Crosswalk's Screen Orientation API flaw
// [Flaw Description]
// Orientation change detection is done in TopBox (iframe).
// However, Crosswalk won't fire change event in all frame if top frame dosen't use Screen Orientation API
// [Solution]
// Use the Screen Orientation API in top frame
(function () {

if (window.screen != null) {

    var orientation = window.screen.orientation || window.screen.mozOrientation || window.screen.msOrientation;

    if (orientation != null) {

        console.log(__GLOBAL_LOG_PREFIX__, "Orientation Type: " + orientation.type);
    }
}

})();

